import { useEffect } from 'react';

/**
 * A custom hook that sets a default value for a select field in a form.
 *
 * @param {Object} params - The parameters for the hook.
 * @param {string} params.parentField - The name of the parent field.
 * @param {string} params.childField - The name of the child field.
 * @param {any} params.defaultValue - The default value to set.
 * @param {Object} params.formMethods - The form methods from react-hook-form.
 * @param {any} params.triggerValue - The value that triggers setting the default value, also from from react-hook-form.
 * @param {Object} params.formValues - The current values of the form, also from react-hook-form.
 * @param {boolean} params.exceptionalBool - An optional boolean that determines if the default value should be set.
 *
 */
const useSetSelectDefaultValue = ({
    parentField,
    childField,
    defaultValue,
    formMethods,
    triggerValue,
    formValues,
    exceptionalBool = false,
}) => {
    useEffect(() => {
        if (exceptionalBool) return;
        if (!triggerValue || !parentField || !childField || !defaultValue || !formMethods || !formValues) return;
        const setDefaultValue = () => {
            if (
                formValues[childField] === null ||
                formValues[childField] === undefined ||
                formValues[childField] === ''
            ) {
                // 只设置默认值，避免子字段刚挂载时因为未注册而触发校验导致页面报错。
                formMethods.setValue(childField, defaultValue);
            }
        };

        const parentValue = formValues[parentField];

        if (Array.isArray(triggerValue) && triggerValue.length > 0) {
            if (triggerValue.includes(parentValue)) {
                setDefaultValue();
            }
            return;
        }

        if (parentValue === triggerValue) {
            setDefaultValue();
        }
    }, [parentField, childField, defaultValue, formMethods, triggerValue, formValues]);
};

export default useSetSelectDefaultValue;
